import { DatePipe } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonComponent } from '@shared/components/button/button.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { CheckboxComponent } from '@shared/components/form-fields';
import { HowToPlayComponent } from '@shared/components/how-to-play/how-to-play.component';
import { TemplateComponent } from '@shared/components/template/template.component';
import { PhoneMaskDirective } from '@shared/directives';
import {
  AuthThirdVariantConfig,
  CervusAuthPayload,
  FormField,
  SixthVariantConfig,
} from '@shared/models';
import { TransformUrlToBgPipe } from '@shared/pipes';

import { AuthBaseComponent } from '../auth.base.component';

type InfoType = 'phone_number' | 'card_number';

@Component({
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [
    DatePipe,
    FormsModule,
    ButtonComponent,
    FooterComponent,
    TemplateComponent,
    CheckboxComponent,
    PhoneMaskDirective,
    HowToPlayComponent,
    ReactiveFormsModule,
    TransformUrlToBgPipe,
  ],
})
export class Variant3Component extends AuthBaseComponent implements OnInit {
  config = input.required<AuthThirdVariantConfig>();

  public headerV6config: SixthVariantConfig = this.loyaltyChallengeConfig
    .components.header as SixthVariantConfig;

  public formFieldsConfig: FormField[] = [];
  public infoType: InfoType = 'phone_number';
  public currentCampaign = this.dataService.currentCampaign;

  private _signinForm: FormGroup = new FormGroup({});

  get form(): FormGroup {
    return this._signinForm;
  }

  ngOnInit(): void {
    this.formFieldsConfig = this.config().header.signinBloc.form.fields;
    this._signinForm = this.initForm([
      ...this.config().header.signinBloc.form.fields,
      ...(this.config().header.signinBloc.form.additionalFields || []),
    ]);
  }

  submit(): void {
    if (this.formSubmitted() || this._signinForm.invalid) {
      return;
    }

    this.formSubmitted.set(true);
    this.showErrorMessage.set(false);

    const formPayload: {
      info_type: string;
      card_number: string;
      phone_number: string;
    } = this._signinForm.value;

    const card: string = formPayload.card_number;
    const phone: string = formPayload.phone_number;

    const payload: CervusAuthPayload = {
      phone_number: phone.replace(/[()\- ]/g, '').substring(0, 10),
      plenti_number: (card || '').length === 16 ? card : '',
      wellness_number: (card || '').length === 11 ? card : '',
    };

    this.authenticate(payload);
  }

  onInfoTypeChanged(event: InfoType): void {
    const oldControl: FormControl = <FormControl>(
      this._signinForm.get(this.infoType)
    );
    const newControl: FormControl = <FormControl>this._signinForm.get(event);

    oldControl.clearValidators();
    oldControl.updateValueAndValidity();

    newControl.addValidators(Validators.required);
    newControl.updateValueAndValidity();

    this.infoType = event;
    this._signinForm.patchValue({
      card_number: '',
      phone_number: '',
    });
  }
}
